import {
  TIMELIMITLIST
} from '../actions/timeLimit';

import {reducerPackage} from "../../utils";

export const timeLimitList = reducerPackage(TIMELIMITLIST);

